import {Table, Tag} from "antd";
import React, {useState} from "react";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";
import ShipmentTransferModal from "../shipmentTransferModal/ShipmentTransferModal";

const ActiveTransfersTable = ({
    activeTransfers,
    activeTransfersLoading,
    onPageChange,
    refetchActiveTransfers
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedTransfer, setSelectedTransfer] = useState(null);

    const getStatusTag = status => {
        let text = status;

        switch (status) {
            case "created":
                text = "Oluşturuldu";
                break;
            case "availableForDepot":
                text = "Depoya Hazır";
                break;
            case "inTransit":
                text = "Yolda";
                break;
            case "completed":
                text = "Tamamlandı";
                break;
            case "canceled":
                text = "İptal edildi";
                break;
            case "return":
                text = "İade edildi";
                break;
            case "availableForPickup":
                text = "Yola Çıkmaya Hazır";
                break;
            case "readyToTransfer":
                text = "Transfere Hazır";
                break;
            default:
                text = status;
        }

        return <Tag>{text}</Tag>;
    };

    const handleShipmentTransfer = record => {
        setSelectedTransfer(record);
        setIsModalOpen(true);
    };

    return (
        <>
            <Table
                dataSource={activeTransfers?.data}
                loading={activeTransfersLoading}
                pagination={{
                    current: activeTransfers?.pagination?.page,
                    pageSize: activeTransfers?.pagination?.limit,
                    total: activeTransfers?.pagination?.total,
                    onChange: onPageChange
                }}
                scroll={{x: 1000}}
            >
                <Table.Column
                    title="Tarih"
                    dataIndex="transferDate"
                    key="transferDate"
                    width={120}
                />
                <Table.Column
                    title="İl"
                    dataIndex="city"
                    key="city"
                    width={120}
                    render={(city, record) => record?.shipmentDetails?.[0]?.receiver?.city}
                />
                <Table.Column
                    title="Nereden"
                    dataIndex="fromName"
                    key="fromName"
                    width={120}
                    render={fromName => <span>{fromName ? fromName : "-"}</span>}
                />
                <Table.Column
                    title="Nereye"
                    dataIndex="toName"
                    key="toName"
                    width={120}
                    render={(toName, record) => (
                        <span>
                            {record?.type === "lastMile"
                                ? record?.shipmentDetails?.[0]?.receiver?.district
                                : toName}
                        </span>
                    )}
                />
                <Table.Column
                    title="Durum"
                    dataIndex="status"
                    key="status"
                    width={120}
                    render={status => getStatusTag(status)}
                />
                <Table.Column
                    width={120}
                    title="Transfer Tipi"
                    dataIndex="type"
                    key="type"
                    render={type =>
                        type === "midMile"
                            ? "Midmile"
                            : type === "firstMile"
                            ? "Firstmile"
                            : type === "lastMile"
                            ? "Lastmile"
                            : "-"
                    }
                />
                <Table.Column
                    title="Kurye"
                    dataIndex="courier"
                    key="courier"
                    width={120}
                    render={courier => (
                        <a target="_blank" href={`/couriers/${courier?._id}`}>
                            {courier ? courier?.fullname : "-"}
                        </a>
                    )}
                />
                <Table.Column
                    title="Teslimat Sayısı"
                    dataIndex="shipmentCount"
                    key="shipmentCount"
                    width={120}
                    render={count => <span>{count} Teslimat</span>}
                />
                <Table.Column
                    title="Paket Sayısı"
                    dataIndex="packageCount"
                    key="packageCount"
                    width={120}
                    render={count => <span>{count} Paket</span>}
                />
                <Table.Column
                    title="Taranan Paket Sayısı"
                    dataIndex="scannedCount"
                    key="scannedCount"
                    width={120}
                    render={count => <span>{count} Paket</span>}
                />
                <Table.Column
                    title="İşlem"
                    dataIndex="action"
                    key="action"
                    width={120}
                    render={(action, record) => (
                        <CustomButton
                            disabled={!record.shipmentActionsEnabled}
                            onClick={() => handleShipmentTransfer(record)}
                        >
                            Shipment Aktar
                        </CustomButton>
                    )}
                />
            </Table>
            <ShipmentTransferModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                transfer={selectedTransfer}
                refetchActiveTransfers={refetchActiveTransfers}
            />
        </>
    );
};

export default ActiveTransfersTable;
